import React, { useEffect } from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import Header from '../../components/Header';
import Nav from '../../components/Nav';
import { NavLink, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

export default function Tasks() {
    const jwt_access = localStorage.getItem('jwt_access');
    const { me } = useSelector(state => state.auth);
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        if(!jwt_access){
            navigate('/login?redirect_to=' + location.pathname + location.search);
        }
    }, [location, navigate, jwt_access]);

    return (
        me &&
        <HelmetProvider>
            <Helmet>
                <title>Société Mikalo</title>
            </Helmet>

            <Header />

            <Nav />

            <main id="main">
                <nav className='_menu-tab'>
                    <ul>
                        <li><NavLink end to="/tasks/rambos">Asa Rambos</NavLink></li>
                        <li><NavLink to="/tasks/bambous">Asa Bambous</NavLink></li>
                    </ul>
                </nav>

                <Outlet />
            </main>
        </HelmetProvider>
    )
}
